<template>
    <div v-if="success" class="d-flex flex-column">
        <p class="font-body text-muted mb-0 text-start">
            Thank you for your feedback!
        </p>
        <p class="font-body text-muted mb-0 text-start">
            We appreciate your feedback and will use it to improve our service.
        </p>
    </div>
    <form
        v-else
        @submit.prevent="submitForm"
        class="d-flex flex-column main-container"
    >
        <!-- Business Rating -->
        <p class="font-body text-muted mb-0 text-start">
            How would you rate your experience with IPAC Consulting?
        </p>
        <div
            class="d-flex rating-options-container align-items-center justify-content-center"
        >
            <button
                v-for="rating in ratingOptions"
                :key="'business-' + rating.value"
                type="button"
                class="rating-btn"
                :class="{ selected: formData.business_rating === rating.value }"
                @click="formData.business_rating = rating.value"
                :aria-pressed="formData.business_rating === rating.value"
                aria-label="Select Business Rating"
            >
                <img
                    class="rating-icon"
                    :src="rating.icon"
                    :alt="rating.label"
                />
            </button>
        </div>

        <!-- App Rating -->
        <p class="font-body text-muted mb-0">
            How would you rate your experience with your Dashboard?
        </p>
        <div
            class="d-flex rating-options-container align-items-center justify-content-center"
        >
            <button
                v-for="rating in ratingOptions"
                :key="'app-' + rating.value"
                type="button"
                class="rating-btn"
                :class="{ selected: formData.app_rating === rating.value }"
                @click="formData.app_rating = rating.value"
                :aria-pressed="formData.app_rating === rating.value"
                aria-label="Select App Rating"
            >
                <img
                    class="rating-icon"
                    :src="rating.icon"
                    :alt="rating.label"
                />
            </button>
        </div>

        <Field
            label="Feedback"
            v-model="formData.message"
            type="textarea"
            required
            :params="{ placeholder: 'Enter your feedback here' }"
        />

        <Field
            label="Send me a copy of my responses"
            v-model="formData.send_copy"
            type="checkbox"
        />

        <div
            class="d-flex flex-column justify-content-center"
            style="gap: var(--space-4)"
        >
            <div class="divider" />
            <button type="submit" class="btn btn-secondary w-100">
                Submit
            </button>
        </div>
    </form>
</template>

<script>
import Field from '../Field.vue';

export default {
    name: 'FeedbackForm',
    components: {
        Field,
    },
    props: {
        success: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            ratingOptions: [
                {
                    icon: require('@/assets/images/icons/feedback-icons/negative.svg'),
                    value: 'NEGATIVE',
                },
                {
                    icon: require('@/assets/images/icons/feedback-icons/neutral.svg'),
                    value: 'NEUTRAL',
                },
                {
                    icon: require('@/assets/images/icons/feedback-icons/positive.svg'),
                    value: 'POSITIVE',
                },
            ],
            formData: {
                business_rating: null,
                app_rating: null,
                message: '',
                send_copy: false,
            },
        };
    },
    emits: ['submit'],
    watch: {
        success(newVal) {
            if (newVal) {
                this.formData = {
                    business_rating: null,
                    app_rating: null,
                    message: '',
                    send_copy: false,
                };
            }
        },
    },
    methods: {
        submitForm() {
            if (!this.formData.business_rating || !this.formData.app_rating) {
                this.$alertStore.pushError('Please provide both ratings');
                return;
            }
            this.$emit('submit', this.formData);
        },
    },
};
</script>

<style scoped>
.main-container {
    gap: var(--space-6);
}

.form-container {
    gap: var(--space-4);
}

.rating-container {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
}

.rating-options-container {
    gap: var(--space-4);
}

.rating-btn {
    background: var(--neutral-450);
    border: none;
    border-radius: var(--radius-default);
    padding: var(--space-4);
    cursor: pointer;
    transition: all 0.2s ease;
}

.rating-btn:hover {
    background: var(--neutral-600);
}

.rating-btn.selected {
    background: var(--secondary-500);
}

.divider {
    width: 100%;
    height: 1px;
    background: var(--neutral-600);
}

@media (max-width: 767.98px) {
    .main-container {
        gap: var(--space-5);
    }

    .rating-icon {
        width: 60px;
        height: 60px;
    }
}
</style>
